/**
 * MediasUploader service upload is used to upload all media (Photos, Backgrounds, Stickers, ...) to upload servers.
 * It triggers event directly on global model.
 */
fx.service( class MediasUploader extends fx.Service {

    constructor(model)
    {
        super();

        this.model = model;

        // current queue
        this._queueFiles = [];
        this._doneFiles = [];
        // files not uploaded 
        this._errorQueue = [];
        
        this._requests = [];

        this._allFiles = [];


        this._extractedFiles = [];

        //this._currentFile = {_upload : {}};

        this._serverIndex = 0;

        this._failedNumber = 0;
        this._slowUpload = false;
        
        //this._oldUpload = false;
        //this._oldUpload = false;

        //this._finishedEvent = "";

        //this._onProgressHandler = this._onProgress.bind(this);

    }

    // in config app we use model linked to creations
    // in editor, creationModel == model
    get creationModel()
    {
        return this.model.creationModel;
    }

    get model()
    {
        return this._model;
    }

    set model(val)
    {
        if (this.model)
            this.off("event", this._onDataEvent, this.model);

        this._model = val;

        this.on("event", this._onDataEvent, this.model);
    }

    get maxSimulataneous()
    {
        //return fx.service("AIService").waiting ? this.maxSimulatenousFiles : (fx.service("AIService").processing ? 1 : this.maxSimulatenousFiles);
        return fx.service("AIService").processing ? 1 : this.maxSimulatenousFiles;
    }

    get maxSimulatenousFiles()
    {
        return  this._slowUpload ? 2 : (this._failedNumber >= fx.get("settings").maxUploads ? 1 : fx.get("settings").maxUploads);
    }

    get useSlowUpload()
    {
        return this._slowUpload || (this._failedNumber >= 1 && this._failedNumber <= fx.get("settings").maxUploads);
    }

    get useOldUpload()
    {
        return this._failedNumber > fx.get("settings").maxUploads;
    }


    get photos()
    {
        return this._extractedFiles;
    }

    get numExtracted()
    {
        return this._extractedFiles.length;
    }
    
    get numFiles()
    {
        //return this._allFiles.length;
        return this.photoExtractor.total;
    }

    get extracting()
    {
        return this.photoExtractor.processing;
    }

    maxTries(file)
    {
        if (file instanceof models.Sticker ||  file instanceof models.Background)
            return this.creationModel.servers.resourceServers.length;
        else
            return this.creationModel.servers.uploadServers.length;
    }

    /*get uploadURL()
    {
        return this.creationModel.servers.uploadServers.getItemAt(this._serverIndex).url;
    }*/

    uploadURL(file)
    {
        if (file && (file instanceof models.Sticker ||  file instanceof models.Background))
            return this.creationModel.servers.resourceServers.getItemAt(0).url;
        else
        {
            let server = this.creationModel.servers.uploadServers.getItemAt(this._serverIndex);
            return (!file || /*file.isHeic ||*/ file.social || this.useOldUpload) ? server.url : server.chunk_url;  // get old server url if old upload method is selected
        }
    }

    get uploading()
    {
        return this._queueFiles.length > 0 || this._errorQueue.length > 0 || this._requests.length > 0;//this._currentFile._upload.uploading;
    }

    get hasErrors()
    {
        return this._errorQueue.length > 0;
    }

    get photoUploading()
    {
        return this.allFiles.length > 0;

        let uploading = false; //(this._currentFile && this._currentFile instanceof models.Photo && this._currentFile._upload.uploading);
        
        for (let i = 0; i < this._requests.length; i++)
            uploading = uploading || (this._requests[i].currentFile instanceof models.Photo && this._requests[i]._upload && this._requests[i]._upload.uploading);

        if ( !uploading && this._queueFiles.length > 0 )
        {
            for (let i = 0; i < this._queueFiles.length; i++)
            {
                if (this._queueFiles[i] instanceof models.Photo)
                {
                    uploading = true;
                    break;
                }
            }

        }

        return uploading;
    }

  
    get allFiles()
    {
        return this._allFiles;
    }

    addFiles(files)
    {
        this._queueFiles = this._queueFiles.concat(files);
        this._allFiles = this._allFiles.concat(files);

        this._extractedFiles = this._extractedFiles.concat(files);
    }

    get total()
    {
        let total = 0;
        for(let i = 0; i < this.allFiles.length; i++)
            total += this.allFiles[i]._upload ? this.allFiles[i]._upload.size : (this.allFiles[i].file.size ? this.allFiles[i].file.size : fx.get("settings").socialFileSize);

        return total;
    }

    get position()
    {
        let total = 0;
        for(let i = 0; i < this.allFiles.length; i++)
            total += this.allFiles[i]._upload ? (this.allFiles[i]._upload.uploaded ? this.allFiles[i]._upload.size : this.allFiles[i]._upload.loaded) : 0;

        return total;
    }

    get percentage()
    {
        if (this.total == 0)
            return 0;
        else
            return parseInt(this.position * 100 / this.total);
    }

    /*get finishedEvent()
    {
        return this._finishedEvent;
    }

    set finishedEvent(val)
    {
        this._finishedEvent = val;
    }*/


    get multipleSelection()
    {
        return this.fileSelector.multipleSelection;
    }

    set multipleSelection(val)
    {
        this.fileSelector.multipleSelection = val;
    }

    get fileSelector()
	{
		if (!this._fileSelector)
		{
            let fileTypes = [".jpeg", ".jpg", ".png"];
            if (fx.get("mode") != "creating-ia")
                fileTypes.push(".heic");

			this._fileSelector = new fx.components.FileSelector({fileTypes : fileTypes, multipleSelection: true});
			this.on("files-selected", this._onFilesSelected, this._fileSelector);
		}
			
		return this._fileSelector;
	}

	get photoExtractor()
	{
		if (!this._photoExtractor)
		{
			this._photoExtractor = new shared.extractors.PhotoExtractor({data : this.creationModel, thumbSize : 300});
			this.on("photo-extracted", this._onPhotoExtracted, this._photoExtractor);
            this.on("photo-extracted-started", this._onPhotoExtractedStarted, this._photoExtractor);
            this.on("photo-extracted-finished", this._onPhotoExtractedFinished, this._photoExtractor);
		}
			
		return this._photoExtractor;
	}

    // ------------------------------- //
    newRequest(file)
    {
        let request;
        if(this.useOldUpload || file instanceof models.Sticker ||  file instanceof models.Background || file.social)
            request = new requests.OldUploadRequest(this.creationModel);
        else
            request = new requests.UploadRequest(this.creationModel);
        this.on("photo-upload-error", this._photoUploadError, request);
        this.on("chunk-upload-error", this._photoUploadError, request);
        this.on("photo-upload-finished", this._photoUploadFinished, request);
        this.on("photo-upload-progress", this._photoUploadProgress, request);
        this._requests.push(request);

        return request;
    }

    _photoUploadError(event)
    {
        this._failedNumber++;

        let request = event.detail;
        
        this._requests.remove(request);
        
        if (this._queueFiles.indexOf(request.currentFile) == -1)
            this._queueFiles.push(request.currentFile);
        
        this._switchServer();

        request.destroy();

        this.trigger("photo-upload-error");

        this.process();
    }

    _photoUploadProgress(event)
    {
        let data = event.detail;

        if (data && data.speed)
            this._slowUpload = (data.speed < 200);
    }
    
    _photoUploadFinished(event)
    {
        if (this._failedNumber > 0)
            this._failedNumber--;

        let request = event.detail;

        this._requests.remove(request);

        if (!this._authentificationPending)
            this.process();

        request.destroy();

        this.trigger("photo-upload-finished");
    }

    // ------------------------------- //

    _onFilesSelected(event)
	{
        this.trigger(event);

        this.creationModel.photos.event("local-photos-selected", event.detail); 
        
        if (fx.get("mode") != "creating-ia") // for AI : we allow min 20 pictures in Main.js in order to allow processing
		    this.photoExtractor.process(event.detail);
	}

    _onPhotoExtracted(event)
	{
        this.trigger("photo-extracted", event.detail);
        this.upload(event.detail);
	}

    _onPhotoExtractedStarted(event)
    {
        this.trigger("photo-extracted-started");
    }

    _onPhotoExtractedFinished(event)
    {
        this._extractedFiles = [];
        this.trigger("photo-extracted-finished");
    }

    toBeUploaded(photo)
    {
        let found = false;
        for(let i = 0; i < this._requests.length; i++)
            found = found || this._requests[i].currentFile == photo;

        return this._queueFiles.indexOf( photo ) != -1 || found; //this._currentFile == photo;
    }

    selectFiles()
    {
        this.fileSelector.selectFiles();
    }

    upload(data)
    {
        this.trigger("photo-upload", data);

        let newFiles;
        if (data instanceof Array)
            newFiles = data;
        else
            newFiles = [ data ];

        // in case we already tried to upload those pictures, we reset _upload data
        for (let i = 0; i < newFiles.length; i++)
            newFiles[i]._upload = { uploaded : false, 
                                    uploading:false, 
                                    tries : 0, 
                                    loaded : 0, 
                                    size : newFiles[i].file ? (newFiles[i].file.size === undefined ? fx.get("settings").socialFileSize : newFiles[i].file.size) : 0
                                };

        this.addFiles(newFiles);
        
        this.process();
    }

    process()
    {
        if (this.creationModel.servers.length == 0)
            return;

        if (this._queueFiles.length == 0 && this._requests.length == 0)
        {
            this._doneFiles = [];

            if (this._errorQueue.length > 0)
            {
                // while creating IA, just try again to upload failed files
                if (fx.get("mode")=="creating-ia")
                    this.upload(this._errorQueue);
                else
                    this.creationModel.event("files-not-uploaded", this._errorQueue);    

                this._errorQueue = [];
            }
            else
            {
                this.creationModel.event("upload-finished"); // set delay event (250ms), to be sure photo id updates are taken into account
                //this._finishedEvent = "";

                this._allFiles = [];
            }
            
        }
        else
        {
            // sort from used to not used
            this._queueFiles = this._queueFiles.sort( (a, b) => b.number - a.number );

            while (this._queueFiles.length > 0 && this._requests.length < this.maxSimulataneous)
                this._uploadFile(this._queueFiles.shift());
            
            if ((this._queueFiles.length == 0 && this._requests.length == 0) || (this._queueFiles.length > 0 && this._requests.length < this.maxSimulataneous))
                this.process();
        }
    }


    _uploadFile(file)
    {
        if (file.deleted || !(file.file || file.social))
            return;

        this.creationModel.event("upload-file");
        
        if (file._upload.tries > this.maxTries(file))
        {
            this._errorQueue.push( file );
        }
        else
        {
            //this._switchServer(); //Hack to decrease error on upload servers
            this.newRequest(file).uploadFile(this.uploadURL(file), file, this.useSlowUpload);
        }
    }

    _switchServer()
    {
        this._serverIndex++;
        
        if (this._serverIndex >= this.creationModel.servers.uploadServers.length)
            this._serverIndex = 0;
    }


    _onDataEvent(e)
    {
        let event = e.detail.event;
        
        if (event.type == "repository-initialized")
            this.process();

        if (event.type == "register-sent" || event.type == "login-sent")
        {
            if (this._requests.length > 0 /*this._currentFile._upload.uploading*/)
            {
                while(this._requests.length > 0)
                {
                    let request = this._requests.shift();
                    request.currentFile._upload.toResend = true;
                    this._queueFiles.unshift(request.currentFile);
                }
                //this._queueFiles.unshift(this._currentFile);
                //this._currentFile._upload.toResend = true;
                this._authentificationPending = true;
            }
        }

        if (event.type == "login-failed" || event.type == "register-failed" || event.type == "login-succeed" || event.type == "register-succeed")
        {
            this._authentificationPending = false;
            
            this.process();
        }
    }

});

